import {
  Box,
  Button,
  Grid,
  Stack,
  Text,
  styled,
} from '@ltvco/refresh-lib/theme';

export const RecallsSearchFormSection = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  padding: theme.spacing(3),
  border: '1px solid',
  borderColor: theme.palette.divider,
  borderRadius: theme.spacing(1.5),
}));

export const RecallsSearchTypeChipsContainer = styled(Stack)(({ theme }) => ({
  flexWrap: 'wrap',
  gap: theme.spacing(1.375),
  rowGap: theme.spacing(1),
}));

export const RecallsSearchFieldContainer = styled(Grid)(({ theme }) => ({
  height: '56px',
  display: 'flex',
  alignItems: 'stretch',
  border: `1px solid ${theme.palette.text.disabled}`,
  borderRadius: theme.spacing(4),
  backgroundColor: theme.palette.background.paper,
  width: '100%',
  margin: theme.spacing(2.5, 0),

  '&:focus-within': {
    borderColor: theme.palette.primary.main,
  },

  '&.error': {
    borderColor: theme.palette.error.main,
  },

  [theme.breakpoints.down('md')]: {
    height: '52px',
  },

  [theme.breakpoints.down('sm')]: {
    margin: 0,
    minHeight: '56px',
    height: 'auto',
  },
}));

export const RecallsFormContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const RecallsIntegratedSearchContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  height: '100%',
  alignItems: 'center',
  borderRadius: theme.spacing(4),
  flexDirection: 'row',
  overflow: 'hidden',
  backgroundColor: theme.palette.common.white,
}));

export const RecallsSearchGridInner = styled(Grid)(() => ({
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  height: '100%',
}));

export const RecallsSearchTypeSelectWrapper = styled(Box)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  alignItems: 'stretch',
  '& .MuiFormControl-root': {
    minWidth: '190px',
    height: '100%',
    minHeight: 0,
    [theme.breakpoints.down('sm')]: {
      minWidth: 0,
      width: '100%',
      flex: 1,
    },
  },
  '& .MuiOutlinedInput-root': {
    height: '100%',
    minHeight: 0,
    [theme.breakpoints.down('sm')]: {
      minHeight: '56px',
    },
  },
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const SearchButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1, 2.75),
  width: '132px',
  height: '56px',
  borderRadius: theme.spacing(4),
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  fontWeight: 700,
  fontSize: '16px',
  lineHeight: '1.625em',
  letterSpacing: '0.02875em',
  textTransform: 'none',

  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },

  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const RecallsSelectInputContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  textAlign: 'right',

  '& .MuiFormControl-root': {
    width: '100%',
    height: '100%',
    borderLeft: `1px solid ${theme.palette.divider}`,

    [theme.breakpoints.down('sm')]: {
      borderLeft: 'none',
    },
  },

  '& .MuiOutlinedInput-root': {
    height: '100%',
    borderRadius: `${theme.spacing(0)} ${theme.spacing(4)} ${theme.spacing(
      4
    )} ${theme.spacing(0)}`,
    textAlign: 'left',

    [theme.breakpoints.down('sm')]: {
      borderRadius: theme.spacing(4),
    },
  },

  '& .MuiSelect-select': {
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    alignItems: 'center',

    [theme.breakpoints.down('sm')]: {
      borderRadius: theme.spacing(4),
    },
  },
}));

export const RecallsYMMWrapper = styled(Box)(() => ({
  flex: 1,
  minWidth: 0,
  display: 'flex',
  alignItems: 'center',
}));

export const RecallsCardsGrid = styled(Stack)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(348px, 1fr))',
  gap: theme.spacing(2),
  width: '100%',
  alignItems: 'stretch',
}));

export const RecallsCardViewMoreButton = styled(Button)(({ theme }) => ({
  fontWeight: 700,
  fontSize: 15,
  textTransform: 'none',
  minWidth: 0,
  paddingLeft: theme.spacing(1.25),
  paddingRight: theme.spacing(1.25),
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

export const RecallsCardViewMoreButtonMobile = styled(Button)(({ theme }) => ({
  fontWeight: 700,
  fontSize: 15,
  width: '100%',
  textTransform: 'none',
  marginTop: theme.spacing(3),
  paddingLeft: theme.spacing(1.25),
  paddingRight: theme.spacing(1.25),
  [theme.breakpoints.up('sm')]: {
    display: 'none',
  },
}));

export const RecallCardMainStack = styled(Stack)(() => ({
  flex: 1,
  minHeight: 0,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

export const RecallCardMainContent = styled(Box)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  wordBreak: 'break-word',
  color: theme.palette.text.primary,
  width: '100%',
  paddingTop: theme.spacing(1),
}));

export const RecallReasonPill = styled(Stack)(({ theme }) => ({
  fontSize: 14,
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  paddingTop: theme.spacing(0.25),
  paddingBottom: theme.spacing(0.25),
  borderRadius: 999,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
}));

export const RecallCardWarningBackdrop = styled(Box)(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  top: -4,
  bottom: 0,
  borderRadius: theme.spacing(2.5),
  backgroundColor: theme.palette.error.main,
  zIndex: 0,
  pointerEvents: 'none',
}));

export const RecallCardContainer = styled(Stack)(({ theme }) => ({
  zIndex: 1,
  position: 'relative',
  display: 'flex',
  minWidth: 348,
  minHeight: 0,
  width: '100%',
  flex: 1,
  border: '1px solid',
  borderColor: theme.palette.divider,
  borderRadius: theme.spacing(2.5),
  flexDirection: 'column',
  backgroundColor: theme.palette.background.paper,
}));

export const RecallDescriptionText = styled(Text)(() => ({
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

export const RecallTwoLineText = styled(Text)(() => ({
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

export const RecallFieldRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: theme.spacing(0.5),
}));

export const RecallCardMetricTilesRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  width: '100%',
  flexShrink: 0,
}));

export const RecallCardMetricTile = styled(Stack)(({ theme }) => ({
  flex: '1 1 0',
  minWidth: 72,
  height: 54,
  maxWidth: '100%',
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.action.hover,
  padding: theme.spacing(1),
  gap: theme.spacing(0.25),
  textAlign: 'center',
  justifyContent: 'center',
  alignItems: 'center',
}));
